import { GeoLocation } from 'types/geoip'
import { EndUser } from 'types/user'
import { VisitInformation } from 'types/visitInformation'
import { createAction } from 'utils/redux'

export const receiveGeo = (payload: GeoLocation) => createAction({
  type: 'RECEIVE_GEO',
  payload
})

export const receiveVisitInformation = (payload: Partial<VisitInformation>) => createAction({
  type: 'RECEIVE_VISIT_INFO',
  payload
})

export const receiveContext = payload => createAction({
  type: 'RECEIVE_CONTEXT',
  payload
})

export const receiveAccessToken = (payload: { accessToken: string }) => createAction({
  type: 'RECEIVE_ACCESS_TOKEN',
  payload
})

export const receiveChatSocketAuth = payload => createAction({
  type: 'RECEIVE_CHAT_SOCKET_AUTH',
  payload
})

export const receivePresenceSocketAuth = payload => createAction({
  type: 'RECEIVE_PRESENCE_SOCKET_AUTH',
  payload
})

export const receiveSocket = payload => createAction({
  type: 'RECEIVE_SOCKET',
  payload
})

export const receiveChannel = payload => createAction({
  type: 'RECEIVE_CHANNEL',
  payload
})

export const receiveEndUser = (payload: { endUser: Partial<EndUser>, assignedAgentId?: string }) => createAction({
  type: 'RECEIVE_END_USER',
  payload
})

export const receiveExternalEmail = payload => createAction({
  type: 'RECEIVE_EXTERNAL_EMAIL',
  payload
})

export const receiveExternalJwt = payload => createAction({
  type: 'RECEIVE_EXTERNAL_JWT',
  payload
})

export const clearExternalJwt = () => receiveExternalJwt(null)

export const waitForExternalJwt = () => createAction({
  type: 'WAIT_FOR_EXTERNAL_JWT'
})

export const receiveUpdatedCampaignRefreshToken = payload => createAction({
  type: 'RECEIVE_UPDATED_CAMPAIGN_REFRESH_TOKEN',
  payload
})

export const receiveExternalId = payload => createAction({
  type: 'RECEIVE_EXTERNAL_ID',
  payload
})

export const identifyLead = (payload: { email: string }) => createAction({
  type: 'IDENTIFY_LEAD',
  payload
})

export const clearExternalId = () => receiveExternalId(null)

export const receiveGDPR = payload => createAction({
  type: 'RECEIVE_GDPR',
  payload
})

export const receiveAccount = payload => createAction({
  type: 'RECEIVE_ACCOUNT',
  payload
})

export const receiveSession = payload => createAction({
  type: 'RECEIVE_SESSION',
  payload
})

export const updateInstanceId = payload => createAction({
  type: 'UPDATE_INSTANCE_ID',
  payload
})


export const receiveCookieDomain = payload => createAction({
  type: 'RECEIVE_COOKIE_DOMAIN',
  payload
})

export const pushToChannel = (clusterName: string, channelName: string, eventName: string, payload: Record<string, any>) =>
  createAction({
    type: 'PUSH_TO_CHANNEL',
    meta: {
      clusterName,
      channelName,
      eventName
    },
    payload
  })
